/**
 * @file Base grid drag component.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ElementRef, NgZone, OnInit } from '@angular/core';
import { ControlBase } from '../../base/helpers/control-base';
var GridDragBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GridDragBaseComponent, _super);
    /**
     * Creates an instance of GridDragBaseComponent.
     * @param {configurationsService} configurationsService
     */
    function GridDragBaseComponent(alertsService, executorsService, dropTargetsService, elementRef, ngZone, localStorageService, gridService) {
        var _this = _super.call(this, alertsService) || this;
        _this.alertsService = alertsService;
        _this.executorsService = executorsService;
        _this.dropTargetsService = dropTargetsService;
        _this.elementRef = elementRef;
        _this.ngZone = ngZone;
        _this.localStorageService = localStorageService;
        _this.gridService = gridService;
        // Keep track of when the application is in drag mode
        _this.inDragMode = false;
        _this.configTasksSource = undefined;
        _this.configAppointmentsSource = undefined;
        _this.configServicesSource = undefined;
        _this.configAbsencesSource = undefined;
        /**
         * Holding Reference of pinned
         * @private
         * @type {boolean}
         */
        _this._pinned = false;
        return _this;
    }
    GridDragBaseComponent.prototype.onDragOver = function (event) {
        // Start the drag mode
        this.inDragMode = true;
        // Close the source to make the resources visible if the sources are not pinned.
        if (!this.pinned) {
            this.closeSource();
        }
    };
    GridDragBaseComponent.prototype.onDragLeave = function (event) {
        // Stop the drag mode
        this.inDragMode = false;
        // Clear the drop targets
        this.dropTargetsService.clearDropTargets();
    };
    Object.defineProperty(GridDragBaseComponent.prototype, "pinned", {
        /**
         * Gets the pinned state.
         * @type {boolean}
         */
        get: function () {
            return this._pinned;
        },
        /**
         * Sets the pinned state
         */
        set: function (value) {
            this.localStorageService.updateProperty('local', 'dragsources-pinned', value);
            this._pinned = value;
            // First close any open drag source
            if (value === false) {
                this.closeSource();
            }
        },
        enumerable: true,
        configurable: true
    });
    GridDragBaseComponent.prototype.togglePinned = function () {
        this.pinned = !this.pinned;
    };
    GridDragBaseComponent.prototype.openSource = function (dragSource) {
        clearTimeout(this.closeTimer);
        this.dragSourceOpen = dragSource;
        this.lastOpenedDragsource = dragSource;
    };
    GridDragBaseComponent.prototype.isSourceOpen = function (dragSource) {
        return (this.dragSourceOpen === dragSource);
    };
    GridDragBaseComponent.prototype.isLastOpenedDragsource = function (dragSource) {
        return (this.lastOpenedDragsource === dragSource);
    };
    GridDragBaseComponent.prototype.closeSource = function () {
        this.lastOpenedDragsource = (this.pinned === true) ? this.dragSourceOpen : undefined;
        this.dragSourceOpen = undefined;
    };
    // called at mouseleave dragsources
    GridDragBaseComponent.prototype.closeSourceDelayed = function () {
        var _this = this;
        this.closeTimer = window.setTimeout(function () {
            _this.closeSource();
        }, 1000);
    };
    Object.defineProperty(GridDragBaseComponent.prototype, "visibleHourStart", {
        /**
         * The start hour of the day the component is using
         * This is fetched from the settings
         *
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleHoursStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDragBaseComponent.prototype, "visibleHoursEnd", {
        /**
         * The end hour of the day the component is using
         * This is fetched from the settings
         *
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleHoursEnd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDragBaseComponent.prototype, "visibleDays", {
        /**
         * Day numbers that should be displayed
         * Sunday = 0, monday = 1, ...
         * These days are fetched from the settings and dependant on the 'weekend' checkbox
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleDays;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Handling the drop event (in this case only an delete!)
     * @param {DragEvent} event
     */
    GridDragBaseComponent.prototype.dropItem = function (event) {
        var _this = this;
        // Prevent the default handling of the element
        event.preventDefault();
        // Get the executor id from the drag data
        /* Fix issue: Xerius: Bij aanlog via IE is het niet mogelijk om Afwezigheden /Services te droppen op Planbord #2718
         * Oplossing gebruik alleen 'Text' bij dataTransfer.
         * Zie: https://stackoverflow.com/questions/26213011/html5-dragdrop-issue-in-internet-explorer-datatransfer-property-access-not-pos
         */
        var executorId = event.dataTransfer.getData('Text');
        // Use the executor id to find the executor event
        var executorEvent = this.executorsService.getExecutorEventById(executorId);
        // By the drag start the executor name is set but if a drop is performed on the 'delete' button in
        // the DragSource we need to rewrite the orginal executor name to match against the correct delete executor.
        var executorName;
        switch (executorEvent.executorName) {
            case 'absence-move':
                executorName = 'absence-delete';
                break;
            case 'appointment-move':
                executorName = 'appointment-delete';
                break;
            case 'assignment-move':
                executorName = 'assignment-delete';
                break;
            case 'attendant-move':
                executorName = 'attendant-delete';
                break;
        }
        // If the executor name is still undefined this means there is no 'real' delete needed
        // for this drop. For example a drag started from the DragSourceBase and dropped on the
        // delete button. In this case there is no Entity created, the user want to stop the dragging.
        if (executorName) {
            // Initiate the executors
            this.executorsService.initiate(executorName, executorEvent.data).then(function (_a) {
                var items = _a[0], successMessage = _a[1];
                // Execution is successful
                _this.alertsService.createAlert('success', successMessage); // Todo; communicate that the delete was succesfull
            }).catch(function (error) {
                // Something went wrong
                if (error.entityErrors && error.entityErrors.length > 0) {
                    // Error alert already created by executor.
                    return;
                }
                _this.alertsService.createAlert('danger', (typeof error === 'string') ? error : 'APP.EXECUTORS.EXECUTION_FAILED', (typeof error === 'string') ? undefined : error);
            });
        }
        else {
            console.log('No (real) deletion needed.');
        }
    };
    /**
     * Handling the drag over event
     * @param {DragEvent} event
     */
    GridDragBaseComponent.prototype.dragOver = function (event) {
        event.stopPropagation();
        event.preventDefault();
    };
    /**
     * Is called during the initialization of the component
     *
     */
    GridDragBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        // The dragover event is needed to make a drop work. The problem is that for every move the draggable
        // item fires the dragover event of Angular and a change detection is handled.  This is per pixel (!)
        // so it's quite slow to 're-render' the grid. Therefore I placed the dragover event outside Angular via NgZone.
        // This construction is used in grid-display-base.component.ts, grid-drag-base.component.ts, plugin-view-shifts and grid-bar-base.component.ts.
        this.ngZone.runOutsideAngular(function () {
            _this.elementRef.nativeElement.addEventListener('dragover', function (event) {
                event.stopPropagation();
                event.preventDefault();
            });
            _this.elementRef.nativeElement.addEventListener('drop', function (event) {
                event.stopPropagation();
                event.preventDefault();
            });
        });
        this._pinned = this.localStorageService.readProperty('local', 'dragsources-pinned', false, [true, false]);
        if (this.pinned === true) {
            this.openSource('tasks');
        }
    };
    return GridDragBaseComponent;
}(ControlBase));
export { GridDragBaseComponent };
